import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface SectionHeadingProps {
  step: number;
  title: string;
  description: string;
  action?: ReactNode;
}

export const SectionHeading = ({ step, title, description, action }: SectionHeadingProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: { xs: 'flex-start', sm: 'center' },
      justifyContent: 'space-between',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 1,
      mb: 2,
    }}
  >
    <Box display="flex" alignItems="flex-start" gap={1.5}>
      <Box
        aria-hidden
        sx={{
          flexShrink: 0,
          width: 26,
          height: 26,
          mt: 0.25,
          borderRadius: '50%',
          bgcolor: 'primary.50',
          color: 'primary.main',
          display: 'grid',
          placeItems: 'center',
          fontSize: '0.75rem',
          fontWeight: 700,
        }}
      >
        {step}
      </Box>
      <Box>
        <Typography variant="subtitle1" fontWeight={700} lineHeight={1.3}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
    </Box>
    {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
  </Box>
);
